import { Component, OnInit } from '@angular/core';
import { OAuthService } from './oauth.service';
import { AuthStatus } from './auth.state';
import { takeWhile } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
    selector: 'app-login',
    template: '',
    styles: [],
})
export class LoginComponent implements OnInit {
    constructor(private oauth: OAuthService, private router: Router) {}

    ngOnInit() {
        this.oauth.authEvents$.pipe(takeWhile((val) => val !== AuthStatus.AUTH_VALID)).subscribe(() => {
            this.router.navigate(['/dashboard']);
        });
    }
}
